module.exports = __webpack_public_path__ + "img/phone.3068188f.svg";